import React, { useState, useEffect, useContext } from 'react';

import { useSelector, useDispatch } from 'react-redux';
import { getIsGlobalUser } from '../../../features/loginSystem/selectors';
import {
  getAvailableLanguages,
  getCallback,
  getConfigs,
  getIsDataDirty,
  getMarketConfig,
  getMarketLanguage,
  getLanguage
} from '../../../features/app/selectors';
import SectionMandatoryHeader from '../../Form/Fields/SectionMandatoryHeader';
import FormContext from '../../Form/FormContext';
import ErrorMessage from '../../Form/Fields/ErrorMessage';

import { States } from '../../../features/PpsiContainer/constants';
import { useParams } from 'react-router-dom';

import {
  FormControlLabel,
  Checkbox,
  FormControl,
  FormLabel,
  FormGroup,
  Grid,
  Divider,
  Box,
  Button
} from '@material-ui/core';
import { saveAvailabilityTab } from 'features/PpsiContainer/actions';

function AvailabilityTabContent() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const { getFieldValue, setFieldValue, data } = useContext(FormContext);
  const getStoreCode = getFieldValue('storeCode');
  const getSalesPointCode = getFieldValue('salesPointCode');
  const upToDate = getFieldValue('upToDate');
  const isGlobalUser = useSelector(getIsGlobalUser);
  const confData = useSelector(getConfigs).toJS();
  const marketConfigData = useSelector(getMarketConfig).toJS();
  const marketLanguages = useSelector(getMarketLanguage);
  const lang = useSelector(getLanguage);
  const callback = useSelector(getCallback);
  const isDataDirty = useSelector(getIsDataDirty);
  const languages = useSelector(getAvailableLanguages);
  console.log(languages, 'get available lang');
  const language =
    isGlobalUser && data.status === States.GLOBALREVIEW
      ? marketLanguages
      : lang;

  const getConfigData =
    isGlobalUser && data.status === States.GLOBALREVIEW
      ? marketConfigData
      : confData;
  const isLocalUser = !isGlobalUser;
  const storeList = [];
  const salesArea = [];

  getConfigData &&
    getConfigData.salesPoint
      .filter(itm => itm.isActive)
      .map(item => {
        const obj = {};
        obj.code = item.code;
        obj.name = item.info[language].name;
        salesArea.push(obj);
      });

  getConfigData &&
    getConfigData.stores.map(item => {
      const obj = {};
      obj.code = item.code;
      obj.name = item.info[language].name;
      storeList.push(obj);
    });

  // adding alphabetical sorting to sales and store selection lists to render in UI.

  const storeLists = storeList.sort((a, b) => a.name.localeCompare(b.name));
  const salesAreas = salesArea.sort((a, b) => a.name.localeCompare(b.name));

  // setting sales area code, by default adding all sales area codes selected
  const salesAreaCode = salesAreas && salesAreas.map(i => i.code);

  // setting store code, by default adding all store codes selected
  const storeListsCode = storeLists && storeLists.map(i => i.code);

  const [allChecked, setSAllChecked] = useState(true);
  const [storeAllChecked, setStoreAllChecked] = useState(true);
  const [salesPoint, setSalesPoint] = useState(data.salesPointCode);
  const [stores, setStores] = useState(data.storeCode);
  const [showSalesErr, setShowSalesErr] = useState(false);
  const [showStoreErr, setShowStoreErr] = useState(false);
  const [isButtonDisable, setIsButtonDisable] = useState(false);

  const checkedHandler = e => {
    let values = [...data.salesPointCode];
    if (e.target.value === 'all') {
      setSAllChecked(e.target.checked);
      e.target.checked === true ? (values = [...salesAreaCode]) : (values = []);
    } else {
      const index = values.indexOf(e.target.value);
      if (index === -1) {
        values = [...data.salesPointCode, e.target.value];
      } else {
        values = values.filter(i => i !== e.target.value);
      }
    }
    data.salesPointCode.length === 0
      ? setShowSalesErr(true)
      : setShowSalesErr(false);
    data.salesPointCode = values;
    setFieldValue('salesPointCode', values);
    setSalesPoint(data.salesPointCode);
    setIsButtonDisable(true);
  };

  const storeListsHandler = e => {
    let values = [...data.storeCode];
    if (e.target.value === 'all') {
      setStoreAllChecked(e.target.checked);
      e.target.checked === false
        ? (values = [])
        : (values = [...storeListsCode]);
    } else {
      const index = values.indexOf(e.target.value);
      if (index === -1) {
        values = [...data.storeCode, e.target.value];
      } else {
        values = values.filter(i => i !== e.target.value);
      }
    }
    data.storeCode.length === 0
      ? setShowStoreErr(true)
      : setShowStoreErr(false);
    data.storeCode = values;
    setFieldValue('storeCode', values);
    setStores(data.storeCode);
    setIsButtonDisable(true);
  };
  // Available store and sales point disable onpublished condition
  function isDisableAvailabileStoreAndSales() {
    if (
      // (data.status === States.PUBLISHED && isLocalUser) ||
      (data.status === States.UNPUBLISHED && isLocalUser) ||
      data.status === States.GLOBALREVIEW
    ) {
      return true;
    }
    return false;
  }
  const isShowSaveButton =
    (data.status === States.PUBLISHED && isLocalUser) ||
    (data.status === States.GLOBALAPPROVED && isLocalUser) ||
    (data.status === States.SCHEDULED && isLocalUser);

  const storeDisplayData =
    storeListsCode.length === 0 ? (
      <p style={{ fontSize: '1rem' }}>STORE DETAILS NOT AVAILABLE</p>
    ) : (
      <FormControl margin="dense" fullWidth variant="filled">
        <SectionMandatoryHeader
          translationId="ppsi.availabilityStoresHeader"
          visable={isDisableAvailabileStoreAndSales()}
        />
        {showStoreErr === true ? (
          <ErrorMessage translationId="ppsi.availabilityStoreErrorMessage" />
        ) : null}
        <Divider />
        <FormGroup>
          <Grid container>
            {storeLists && storeLists.length > 1 && (
              <Grid item xs={4}>
                <FormControlLabel
                  label="All"
                  control={
                    <Checkbox
                      value="all"
                      checked={storeAllChecked}
                      disabled={isDisableAvailabileStoreAndSales()}
                      onChange={storeListsHandler}
                    />
                  }
                />
              </Grid>
            )}
            {storeLists &&
              storeLists.map(item => {
                const { code, name } = item;
                return (
                  <Grid item xs={4} key={code}>
                    <FormControlLabel
                      label={name}
                      control={
                        <Checkbox
                          value={code}
                          disabled={isDisableAvailabileStoreAndSales()}
                          checked={data.storeCode.includes(code)}
                          onChange={storeListsHandler}
                        />
                      }
                    />
                  </Grid>
                );
              })}
          </Grid>
        </FormGroup>
      </FormControl>
    );

  useEffect(() => {
    storeLists.length !== data.storeCode.length
      ? setStoreAllChecked(false)
      : setStoreAllChecked(true);
    // salesAreaCode.length !== data.salesPointCode.length
    salesAreaCode.length !==
    data.salesPointCode.filter(itm => salesAreaCode.includes(itm)).length
      ? setSAllChecked(false)
      : setSAllChecked(true);
    data.storeCode.length === 0
      ? setShowStoreErr(true)
      : setShowStoreErr(false);
    data.salesPointCode.length === 0
      ? setShowSalesErr(true)
      : setShowSalesErr(false);
  }, [stores, salesPoint, data.salesPointCode, data.storeCode]);

  const handleSaveSalesAndStore = e => {
    const { status } = data;
    const storeSalesData = { salesPointCode: salesPoint, storeCode: stores };
    dispatch(saveAvailabilityTab(id, status, storeSalesData, callback));
    setIsButtonDisable(false);
    // console.log(id, data,"handle save")
  };
  return (
    <>
      {!isGlobalUser || (isGlobalUser && data.status === States.GLOBALREVIEW)
        ? storeDisplayData
        : null}
      <FormControl margin="dense" fullWidth variant="filled">
        <SectionMandatoryHeader
          translationId="ppsi.availabilitySalesHeader"
          visable={isDisableAvailabileStoreAndSales()}
        />
        {showSalesErr === true ? (
          <ErrorMessage translationId="ppsi.availabilitySalesErrorMessage" />
        ) : null}
        <Divider />
        <FormGroup>
          <Grid container>
            {salesAreas && salesAreas.length > 1 && (
              <Grid item xs={4}>
                <FormControlLabel
                  label="All"
                  control={
                    <Checkbox
                      value="all"
                      checked={allChecked}
                      disabled={isDisableAvailabileStoreAndSales()}
                      onChange={checkedHandler}
                    />
                  }
                />
              </Grid>
            )}
            {salesAreas &&
              salesAreas.map(item => {
                const { code, name } = item;
                return (
                  <Grid item xs={4} key={code}>
                    <FormControlLabel
                      label={name}
                      control={
                        <Checkbox
                          value={code}
                          checked={data.salesPointCode.includes(code)}
                          disabled={isDisableAvailabileStoreAndSales()}
                          onChange={checkedHandler}
                        />
                      }
                    />
                  </Grid>
                );
              })}
          </Grid>
        </FormGroup>
      </FormControl>
      {/* {isShowSaveButton && (
        <Grid container>
          <Grid item xs={12} style={{ textAlign: 'left' }}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleSaveSalesAndStore}
              disabled={!isButtonDisable}
            >
              Update
            </Button>
          </Grid>
        </Grid>
      )} */}
    </>
  );
}

export default AvailabilityTabContent;
